const fireBaseConfig = {
  apiKey: "AIzaSyCHYGgKwK0k8v0dU8xqrlnj8gTqPdj2fKA",
  authDomain: "iturramasat-cfb32.firebaseapp.com",
  databaseURL: "https://iturramasat-cfb32.firebaseio.com",
  projectId: "iturramasat-cfb32",
  storageBucket: "iturramasat-cfb32.appspot.com",
  messagingSenderId: "644618549971"
};

const socketServer = {
  "a_sat": "https://stream.iturramasat.com:3000"
}

const baseUrl = 'sats/' + localStorage.sat + "/";

const config = {
  fireBaseConfig: fireBaseConfig,
  socketServer: socketServer,
  baseUrl: baseUrl,
  mapsApiKey: "AIzaSyAVNTRVD-m3pfSprnE-QWwq2EcDmmHqvl0"
}

module.exports = config;
